var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 6.60016L11.0782 1.45425C10.9981 0.999938 10.6031 0.680298 10.1572 0.680298C10.1032 0.680298 2.21126 2.06688 2.21126 2.06688C1.70196 2.1567 1.36188 2.64237 1.4517 3.15166L1.53916 3.64777H8.66168C9.56527 3.64777 10.3004 4.38288 10.3004 5.28647V7.84814L11.226 7.68492C11.7353 7.59513 12.0754 7.10946 11.9856 6.60016ZM9.59808 8.23847H0V10.3833C0 10.9004 0.41925 11.3197 0.936398 11.3197H8.66168C9.17883 11.3197 9.59808 10.9004 9.59808 10.3833V8.23847ZM2.78782 10.476H1.19477C1.00085 10.476 0.843633 10.3188 0.843633 10.1249C0.843633 9.93094 1.00085 9.77372 1.19477 9.77372H2.78782C2.98174 9.77372 3.13896 9.93094 3.13896 10.1249C3.13896 10.3188 2.98177 10.476 2.78782 10.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00114844 5.24084H9.5969C9.57309 4.74488 9.1635 4.3501 8.66166 4.3501H0.936398C0.434555 4.3501 0.0249609 4.74488 0.00114844 5.24084ZM0 5.94312H9.59808V7.53617H0V5.94312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCards);
export default __webpack_public_path__ + "static/media/bank-cards.f2090c2a8732503335177ad6f89b5bd7.svg";
export { ForwardRef as ReactComponent };